import React from "react";
import { Users, CreditCard, Smartphone, Car, Hourglass, ClipboardList, Tag } from "lucide-react";

const MONTH_LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function formatMonthLabel(month) {
    const [yearText, monthText] = String(month || "").split("-");
    const year = Number(yearText);
    const monthNumber = Number(monthText);

    if (!year || !monthNumber || !MONTH_LABELS[monthNumber - 1]) return "Previous month";
    return `${MONTH_LABELS[monthNumber - 1]} ${year}`;
}

function formatCount(value) {
    return new Intl.NumberFormat("en-US").format(Number(value) || 0);
}

function RoomReportTotalAreaBranchDetailsDay(props) {
    const { data, onExpandCard } = props;
    const previousMonthSummary = data?.previousMonthSummary || null;
    const previousMonthLabel = formatMonthLabel(previousMonthSummary?.reportMonth);

    function buildPreviousMonthSubText(detailType) {
        if (!previousMonthSummary) return "";

        if (detailType === "female") {
            const roomTotal = Number(previousMonthSummary.roomTotal || 0);
            const femaleTotal = Number(previousMonthSummary.femaleTotal || 0);
            const femaleRatio = roomTotal > 0 ? Math.round((femaleTotal / roomTotal) * 100) : 0;
            return ` ${previousMonthLabel}: ${formatCount(femaleTotal)} customers (${femaleRatio}%)`;
        }

        if (detailType === "membership") {
            return ` ${previousMonthLabel}: ${formatCount(previousMonthSummary.memberShipTotal)} nights`;
        }

        if (detailType === "appweb") {
            const appTotal = Number(previousMonthSummary.fromAzAppTotal || 0);
            const webTotal = Number(previousMonthSummary.fromAzWebTotal || 0);
            return ` ${previousMonthLabel}: ${formatCount(appTotal + webTotal)} turns (App: ${formatCount(appTotal)} | Web: ${formatCount(webTotal)})`;
        }

        if (detailType === "car") {
            const pickUpTotal = Number(previousMonthSummary.pickUpTotal || 0);
            const dropOffTotal = Number(previousMonthSummary.dropOffTotal || 0);
            return ` ${previousMonthLabel}: ${formatCount(pickUpTotal + dropOffTotal)} turns (Pick Up: ${formatCount(pickUpTotal)} | Drop Off: ${formatCount(dropOffTotal)})`;
        }

        if (detailType === "cancel_waiting") {
            const cancelListTotal = Number(previousMonthSummary.cancelListTotal || 0);
            const waitingListTotal = Number(previousMonthSummary.waitingListTotal || 0);
            return ` ${previousMonthLabel}: ${formatCount(cancelListTotal + waitingListTotal)} turns (Cancel: ${formatCount(cancelListTotal)} | Waiting: ${formatCount(waitingListTotal)})`;
        }

        if (detailType === "survey") {
            return ` ${previousMonthLabel}: ${formatCount(previousMonthSummary.surveyTotal)} turns`;
        }

        if (detailType === "line_coupon") {
            return ` ${previousMonthLabel}: ${formatCount(previousMonthSummary.totalRoomLine)} turns`;
        }

        return "";
    }

    // Danh sách KPI map từ viewRoom + các biến chờ API
    const kpiItems = [
        // {
        //     title: "Capacity",
        //     value: `${data.capacity || 0}%`,
        //     goal: data.api_goalCapacity || "Goal: 80%", // BIẾN CHỜ
        //     percent: data.capacity || 0,
        //     statusColor: (data.capacity || 0) >= 80 ? "green" : "red",
        //     subText: data.api_vsLastMonthCapacity || "vs. last month: +2.5%", // BIẾN CHỜ
        //     subTextClass: "positive"
        // },
        // {
        //     title: "Total Occupied",
        //     value: data.roomTotal || 0,
        //     unit: " nights",
        //     goal: data.api_goalTotalRoom || "Goal: 500 nights", // BIẾN CHỜ
        //     percent: Math.min(((data.roomTotal || 0) / 500) * 100, 100),
        //     statusColor: "blue",
        //     subText: data.api_vsLastMonthRooms || "* (Total nights booked)", // BIẾN CHỜ
        // },
        {
            title: "Female Ratio",
            detailType: "female",
            icon: Users,
            iconColor: "#DB4437",
            unit: " customer",
            value: `${data.femaleTotal}`,//`${data.roomTotal ? Math.round(((data.femaleTotal || 0) / data.roomTotal) * 100) : 0}%`,
            goal: `Total: ${data.femaleTotal || 0} nights`,
            percent: data.roomTotal ? ((data.femaleTotal || 0) / data.roomTotal) * 100 : 0,
            statusColor: "green",
            subText: buildPreviousMonthSubText("female") || data.api_femaleGrowth || "",
            subTextClass: buildPreviousMonthSubText("female") ? "" : "positive"
        },
        {
            title: "Membership",
            detailType: "membership",
            icon: CreditCard,
            iconColor: "#4285F4",
            value: data.memberShipTotal || 0,
            unit: " nights",
            goal: data.api_goalMembership || "Target: 150", // BIẾN CHỜ
            percent: Math.min(((data.memberShipTotal || 0) / 150) * 100, 100),
            statusColor: "red",
            subText: buildPreviousMonthSubText("membership") || data.api_vsLastMonthMember || "",
            subTextClass: buildPreviousMonthSubText("membership") ? "" : "negative"
        },
        {
            title: "AZ App & Web",
            detailType: "appweb",
            icon: Smartphone,
            iconColor: "#0F9D58",
            value: (data.fromAzAppTotal || 0) + (data.fromAzWebTotal || 0),
            unit: " turns",
            goal: `App: ${data.fromAzAppTotal || 0} | Web: ${data.fromAzWebTotal || 0}`,
            percent: 65, // BIẾN CHỜ API
            statusColor: "green",
            subText: buildPreviousMonthSubText("appweb") || data.api_directBookingGrowth || "",
            subTextClass: buildPreviousMonthSubText("appweb") ? "" : "positive"
        },
        {
            title: "Car by Turn",
            detailType: "car",
            icon: Car,
            iconColor: "#4285F4",
            value: Math.round(data.pickUpTotal || 0) + (data.dropOffTotal || 0),
            unit: " turns",
            goal: `Pick Up : ${data.pickUpTotal} - Drop Off : ${data.dropOffTotal}`,
            percent: 85, // BIẾN CHỜ API
            statusColor: "green",
            subText: buildPreviousMonthSubText("car"),
            subTextClass: ""
        },
        {   
            title: "Cancel & Waiting",
            detailType: "cancel_waiting",
            icon: Hourglass,
            iconColor: "#F4B400",
            value: Math.round(data.cancelListTotal || 0) + (data.waitingListTotal || 0),
            unit: " turns",
            goal: `Cancel List : ${data.cancelListTotal} - Waiting List : ${data.waitingListTotal}`,
            percent: 85, // BIẾN CHỜ API
            statusColor: "green",
            subText: buildPreviousMonthSubText("cancel_waiting"),
            subTextClass: ""
        },
        {
            title: "Survey",
            detailType: "survey",
            icon: ClipboardList,
            iconColor: "#0F9D58",
            value: Math.round(data.surveyTotal || 0),
            unit: " turns",
            goal: ``,
            percent: 0, // BIẾN CHỜ API
            statusColor: "green",
            subText: buildPreviousMonthSubText("survey"),
            subTextClass: ""
        },
        {
            title: "LINE Coupon",
            detailType: "line_coupon",
            icon: Tag,
            iconColor: "#DB4437",
            value: Math.round(data.totalRoomLine || 0),
            unit: " turns",
            goal: ``,
            percent: 0, // BIẾN CHỜ API
            statusColor: "green",
            subText: buildPreviousMonthSubText("line_coupon"),
            subTextClass: ""
        },
    ];

    return (
        <div className="kpi-grid-6">
            {kpiItems.map((item, index) => (
                <div key={index} className="exec-card">
                    <span className="card-expand-icon" onClick={() => onExpandCard && onExpandCard(item)}>⤢</span>
                    <div className="kpi-title-wrap">
                        {item.icon && (
                            <span className="kpi-title-icon" style={{ color: item.iconColor || "var(--accent-blue)" }}>
                                <item.icon size={20} />
                            </span>
                        )}
                        <div className="card-title">{item.title}</div>
                    </div>

                    <div className="card-value-hero">
                        {item.value}
                        {item.unit && <span style={{fontSize:"1.3rem"}}>{item.unit}</span>}
                    </div>

                    <div>
                        <div className="kpi-goal-text">{item.goal}</div>
                        <div className="progress-bar-line">
                            <div
                                className={`progress-bar-fill ${item.statusColor}`}
                                style={{ width: `${item.percent}%` }}
                            />
                        </div>
                        {item.subText && (
                            <div className={`sub-stat-text ${item.subTextClass || ''}`}>
                                {item.subText}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default RoomReportTotalAreaBranchDetailsDay;